import React from 'react';
type SectionLabelProps = {
  children: React.ReactNode;
  tone?: 'green' | 'gold';
};
export function SectionLabel({
  children,
  tone = 'green'
}: SectionLabelProps) {
  const styles = tone === 'gold' ? 'bg-brand-gold/10 text-brand-gold ring-brand-gold/30' : 'bg-brand-greenDeep text-brand-greenSoft ring-brand-green/25';
  return <span className={`inline-block rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-[0.14em] ring-1 ${styles}`} data-id="element-258" data-mp="17pzfx8548bxw">
      {children}
    </span>;
}